export default __webpack_public_path__ + "static/blob3-47b8f90c44f36577e1be7cce62e9a789.svg";